var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "LoadingOverlay",
    {
      attrs: {
        loading: _vm.$apollo.queries.contractorUser.loading,
        hasData: !!_vm.contractorUser,
      },
    },
    [
      _c("ContractorAbout", {
        attrs: {
          company: _vm.company,
          currentUserId: _vm.adminUserId,
          contractorUser: _vm.contractorUser,
          isAccessGranted: _vm.isInCompany,
          hasAllResourceAccess: _vm.hasAllResourceAccess,
          isAdmin: _vm.isAdmin,
        },
        scopedSlots: _vm._u([
          {
            key: "optionalInfo",
            fn: function () {
              return [
                _vm.isInCompany
                  ? _c(
                      "div",
                      { staticClass: "flex flex-wrap" },
                      [
                        _c("CardInfoChip", {
                          staticClass: "mr-3",
                          attrs: { message: "Company member" },
                        }),
                        _vm.contractorId
                          ? _c("ContractorFullInformationLink", {
                              attrs: { contractorId: _vm.contractorId },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                !_vm.isInCompany
                  ? _c("AddContractorToCompany", {
                      attrs: {
                        buttonClasses: "customAddCompanyMarketplaceAdmin",
                        contractorId: _vm.contractorId,
                        currentUserRole: _vm.roles.ADMIN,
                        currentUserId: _vm.adminUserId,
                        companyId: _vm.company.id,
                        companyName: _vm.company.business_name,
                        contractorUserId: _vm.contractorUserId,
                      },
                      on: { addedToCompany: _vm.onAddToCompany },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }